export default __webpack_public_path__ + "static/cloudator-full-5-4c5902204a5ccb9fa24173fc35f96ea1.png";